// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// Export the factory function instead of a class to prevent initialization order problems

import type { UserNotification } from "le-coffre-resources/dist/Notary";
import type { QueryFilters, QueryInclude, QuerySelect, QuerySort, RequestOptions } from "../../../types";

// Export types
export interface IGetNotificationsParams {
	where?: QueryFilters;
	include?: QueryInclude;
	select?: QuerySelect;
	orderBy?: QuerySort;
}

export type IPutNotificationsParams = {
	read?: boolean;
};

// Export a compatible interface for backwards compatibility
export interface INotifications {
	get(q?: IGetNotificationsParams, options?: RequestOptions): Promise<UserNotification[]>;
	put(uid: string, body: IPutNotificationsParams): Promise<UserNotification>;
}

import { getLazyFactoryGetter } from "@Front/Api/helpers/dynamicFactoryLoader";

function getFactory(): () => INotifications {
	return getLazyFactoryGetter("LeCoffreApi/Notary/Notifications") as () => INotifications;
}

// Export the instance getter as the main export
export const Notifications = {
	getInstance: (): INotifications => {
		return getFactory()();
	},
};

// Export default for backward compatibility with existing imports
export default Notifications;
